import { render, staticRenderFns } from "./Segurasp.vue?vue&type=template&id=57292526"
import script from "./Segurasp.vue?vue&type=script&lang=js"
export * from "./Segurasp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports